import { CSSObject } from '@chakra-ui/react';

export const LinkForgotPassword: CSSObject = {
  color: 'alpha.400',
  fontSize: 'xs',
  fontWeight: 'medium',
};
